export default {
  title: 'Links',
  new_link: 'Novo link',
  empty_title: 'Nenhum link de compartilhamento.',
  empty_body: 'Gere um link público com prazo de validade para mostrar a posição atual de um dispositivo — quem recebe não precisa de login.',
  load_failed: 'Não foi possível carregar os links.',
  retry_hint: 'Tente novamente em instantes.',
  create_failed: 'Não foi possível gerar o link.',
  revoke_failed: 'Falha ao revogar o link.',
  device_fallback: 'Dispositivo',
  device_unnamed: 'Sem nome',
  no_position_yet: '— sem posição ainda',
  expires_min: 'expira em {count} min',
  expires_hm: 'expira em {h}h{m}min',
  expires_h: 'expira em {h}h',
  expired: 'expirado',
  state: {
    revoked: 'Revogado',
    expired: 'Expirado',
    active: 'Ativo',
  },
  ttl: {
    m15: '15 min',
    m30: '30 min',
    h1: '1 hora',
    h2: '2 horas',
  },
  open_link: 'Abrir link',
  revoke: 'Revogar',
  modal_aria: 'Novo link de compartilhamento',
  modal_title_new: 'Novo link de compartilhamento',
  modal_title_done: 'Link gerado',
  modal_done_body: 'Qualquer pessoa com este link vê a posição de {device} até o prazo expirar.',
  link_url_aria: 'URL do link',
  device_label: 'Dispositivo',
  ttl_label: 'Tempo de vida do link',
  ttl_hint: 'Depois do prazo o link para de funcionar sozinho.',
  generate: 'Gerar link',
}
